import { useQuery } from 'react-query';

import AssessmentService from 'App/services/AssessmentService';

function useFetchAssessmentSettings(categoryId, assessmentId) {
    return useQuery(
        ['categoryId', categoryId, 'assessmentId', assessmentId],
        () => AssessmentService.getAssessmentSettings(categoryId, assessmentId),
        {
            retry: false,
            refetchInterval: false,
            refetchOnWindowFocus: false,
        }
    );
}

export default useFetchAssessmentSettings;
